import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NzDrawerPlacement } from 'ng-zorro-antd/drawer';
import { AppCommon } from 'src/app/api-providers/app-common';
import { LoginViewModel } from 'src/app/api-providers/view-models/login.view.model';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnChanges  {

  notifications:any = []
  count:any
  notificationTitle:any
  @ViewChild(TemplateRef, { static: false }) template?: TemplateRef<{}>;
  page_size= 9 
  page=1
  @Input('visible')  visible = false;
  @Output('setvisible') setvisible = new EventEmitter<boolean>()
  placement: NzDrawerPlacement = 'right';
  next:any
  loggedObject:any
  notificationItemUpdated:number

  constructor(   private router: Router, private vm: LoginViewModel,){
   
    this.loggedObject = AppCommon.getloggedInObject();
  
  }

  ngOnInit(): void {
    
   
  

    this.vm.notification$.subscribe({
     next: ( data ) =>{ 
       const { count, next, previous, results } = data;
       if(previous){
         this.notifications.push(...results)
       }else if(next){
         this.notifications = results; // Only the notification items
       }
       this.next = next
       this.count = count; // Total count of notifications
       this.notificationTitle = 'All notifications - (' + this.notifications?.length +'/' + count + ')'
      //  console.log(this.notifications, count, next, previous, results)
      
     }
    })

   

    this.vm.notificationUpdated$.subscribe({
      next: (data) =>{
        data && ( this.notifications.filter(e => e.id == this.notificationItemUpdated )[0].is_read = 
         !this.notifications.find(e => e.id == this.notificationItemUpdated ).is_read )
      }
    })
    this.vm.notificationCleared$.subscribe({
      next: (data) =>{
        this.close()
        this.notifications = []
      }
    })
  
   }

  ngOnChanges(changes: SimpleChanges) { 
      console.log(this.visible)
      if(this.visible){
        this.vm.getNotification(this.loggedObject.user,this.page_size,this.page)
      }
  }

  close(): void {
    this.visible = false;
    this.setvisible.emit(false)
  }

  getUrl(id){
    return  '/tasks/'+ id
  }
 
  markRead(is_read:any,id){
    this.notificationItemUpdated = id
    this.vm.updateNotification(this.loggedObject.user.id,is_read,id)
  }

  clearAll(){
    this.vm.clearAllNotification(this.loggedObject.user)
  }

  onScroll(num:any){
    // console.log(num.currentScrollPosition)
    if(num.currentScrollPosition > 0 && this.next !== null) {
      this.page++
      this.vm.getNotification(this.loggedObject.user,this.page_size,this.page)
    }
  }
 
}
